/**
 * 编辑和保存公用
 * 编辑时编号不能修改
 */
class SmartGoodsEditCtrl {
    constructor($scope, httpRequest, formvalidateApi, $uibModalInstance, smartGoods, $http, $timeout) {
        // 初始化表单数据
        $scope.smartGoods = { ...smartGoods }
        // 优惠政策
        $scope.privilegeList = [{
            id: 1,
            text: '享受',
        }, {
            id: 0,
            text: '不享受',
        }]
        $scope.taxRateOptions = []
        $scope.taxClassInfo = {
            taxName: '',
            codeVersions: '',
            taxRateList: [],
            discountOptionList: [],
            taxSpecialManageList: [],
        }
        $http.get(`${host.etcloudOvat}settings/sysGoodsInfo/getTaxClassInfo?taxName=${encodeURI($scope.smartGoods.taxMergeName)}`).then((res) => {
            $scope.taxClassInfo = res.data.value
            $scope.smartGoods.taxMergeName = $scope.taxClassInfo.taxName
            $scope.smartGoods.codeVersions = $scope.taxClassInfo.codeVersions
            $scope.smartGoods.taxMergeCode = $scope.taxClassInfo.mergeCode
        })
        // 获取商品税率
        function getGoodsInfoTax(taxRate) {
            if (!$scope.smartGoods.isPrivilege) {
                $scope.smartGoods.taxRate = taxRate || $scope.taxClassInfo.taxRate || $scope.taxClassInfo.taxRateList[0]
                // 不享受优惠政策显示所有税率
                httpRequest.get_qryGoodsInfoTax({
                    taxMergeCode: -1,
                    invType: -1,
                }).then((res) => {
                    $scope.taxRateOptions = res.data.value
                })
            } else {
                // 享受优惠从后台取
                const rateReq = {
                    taxMergeCode: $scope.smartGoods.taxMergeCode,
                    privilegeType: encodeURIComponent($scope.smartGoods.privilegeType),
                    invType: -1,
                }
                httpRequest.get_qryGoodsInfoTax(rateReq).then((res) => {
                    $scope.taxRateOptions = res.data.value
                    $scope.smartGoods.taxRate = taxRate || $scope.taxRateOptions[0]
                })
            }
        }
        $timeout(getGoodsInfoTax($scope.smartGoods.taxRate), 1000)
        // getGoodsInfoTax()
        // 是否享受优化政策
        $scope.changeIsPrivilege = function changeIsPrivilege() {
            if ($scope.smartGoods.isPrivilege === 0) {
                $scope.isPrivilegeFlag = true
                $scope.smartGoods.taxRate = $scope.taxClassInfo.taxRateList[0]
                $scope.smartGoods.privilegeType = ''
            } else {
                $scope.smartGoods.privilegeType = $scope.taxClassInfo.taxSpecialManageList[0]
                $scope.isPrivilegeFlag = false
            }
            httpRequest.get_qryTaxClassInfo($scope.smartGoods.taxMergeCode).then((res) => {
                $scope.taxClassInfo = res.data.value
                getGoodsInfoTax()
            })
        }

        // 优惠政策变化
        $scope.changePrivilegeType = function changePrivilegeType() {
            getGoodsInfoTax()
        }

        $scope.adding = false
        // 编辑保存
        $scope.save = function save() {
            const valid = formvalidateApi.run()
            if (valid) {
                $uibModalInstance.close($scope.smartGoods)
            }
        }
        // 返回
        $scope.cancel = function cancel() {
            $uibModalInstance.dismiss()
        }
    }
}
SmartGoodsEditCtrl.$inject = ['$scope', 'httpRequest', 'formvalidateApi', '$uibModalInstance', 'smartGoods', '$http', '$timeout']
export default SmartGoodsEditCtrl



// WEBPACK FOOTER //
// ./src/app/outputManage/baseData/smartGoods/SmartGoodsEditCtrl.js